<div class="flex-direction-column gap-15">
  <div class="label-lateral">
    <div class="flex align-center" style="width: 100%;">
    <span class="label font-12 weight-600" style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
      {{ canaisOperadores?.nomeCanal ?? '--' }}
    </span>
      <div class="flex gap-10 align-center" style="width: 80px; justify-content: flex-end;">
        <img src="assets/icones/user-headset 3.svg" alt="">
        <span class="font-14 weight-700 info-icones-canais">{{ canaisOperadores?.quantidadeAntendimentos ?? '0' }}</span>
      </div>
      <div class="flex gap-10 align-center" style="width: 80px; justify-content: flex-end;">
        <img src="assets/icones/person-list.svg" alt="">
        <span class="font-14 weight-700 info-icones-canais">{{ canaisOperadores?.quantidadeAtendimentosAtivos ?? '0' }}</span>
      </div>
    </div>
  </div>
  @for (operador of canaisOperadores?.operadoresAtendimento; track operador.idOperador) {
    <div class="flex align-center padding-left-5px padding-right-5px wrap cursor-pointer"
      [style.height]="'37px'" (click)="selecionarOperador(operador, canaisOperadores?.idCanal!)"
      (keydown.enter)="selecionarOperador(operador, canaisOperadores?.idCanal!)" tabindex="0" role="button"
      [ngClass]="{ 'operador-selecionado': (operadorSelecionado && operadorSelecionado.idOperador === operador.idOperador), 'justify-apace-around': (isMobile) }">
      <div class="flex gap-10 align-center" style="flex: 1; min-width: 0;">
        @if (operador.uuidOperador && operador.extensaoImgOperador) {
          <img class="img-usuario" [src]="gerarUrl(operador.uuidOperador, operador.extensaoImgOperador, 'usuario-img')" alt="" />
        } @else {
          <img src="assets/icones/no-img-default.png" alt="" />
        }
        <span class="font-14 weight-700"
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; min-width: 0; max-width: 180px;"
              [matTooltip]="operador.nomeOperador ?? '--'">
      {{ operador.nomeOperador ?? '--' }}
    </span>
        @if (operador.ativoOperador){
          <img matTooltip="Ativo" style="width: 9px; height: 9px; flex-shrink: 0;" src="assets/icones/bolinha-verde.svg" alt="Ativo" />
        } @else {
          <img matTooltip="Inativo" style="width: 9px; height: 9px; flex-shrink: 0;" src="assets/icones/bolinha-vermelha.svg" alt="Inativo" />
        }
      </div>
      <div class="flex gap-15 align-center">
        <div class="flex gap-5 align-center" style="width: 60px; justify-content: flex-end;">
          <img src="assets/icones/user-headset 3.svg" alt="">
          <span class="font-14 weight-700" style="width: 35px; text-align: center;">{{ operador.totalAtendimentos ?? '0' }}</span>
        </div>
        <div class="flex gap-5 align-center" style="width: 60px; justify-content: flex-end;">
          <img src="assets/icones/person-list.svg" alt="">
          <span class="font-14 weight-700" style="width: 35px; text-align: center;">{{ operador.quantidadeAtendimentos ?? '0' }}</span>
        </div>
        <div class="flex gap-5 align-center" style="width: 100px; justify-content: flex-end;">
          <img src="assets/icones/clock.svg" alt="">
          <span class="font-14 weight-700" style="width: 70px; text-align: center;">{{ (isMobile ? Math.floor(operador.tempoMedioEsperaContatos / 60) + 'h' : operador.tempoMedioEsperaContatos | horasMinutos) }}</span>
        </div>
      </div>
    </div>
  }
</div>
